import * as React from 'react';
import { cn } from '@/lib/utils';

type Variant = 'default' | 'navy' | 'blue' | 'cyan' | 'muted' | 'success' | 'warning' | 'destructive' | 'outline';

const map: Record<Variant, string> = {
  default: 'bg-primary/10 text-primary border border-primary/20',
  navy: 'bg-raptor-navy text-white',
  blue: 'bg-raptor-blue text-white',
  cyan: 'bg-raptor-cyan text-raptor-navy',
  muted: 'bg-muted text-muted-foreground border border-border',
  success: 'bg-emerald-100 text-emerald-800 border border-emerald-200',
  warning: 'bg-amber-100 text-amber-800 border border-amber-200',
  destructive: 'bg-red-100 text-red-800 border border-red-200',
  outline: 'border border-border text-raptor-navy',
};

export const Badge: React.FC<React.HTMLAttributes<HTMLSpanElement> & { variant?: Variant }> = ({ variant = 'default', className, ...props }) => (
  <span className={cn('inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-semibold font-tabular', map[variant], className)} {...props} />
);
